import type { SessionState } from '../game/simulation/types';
import type { BgmCue } from './PhaseBgm';
import { DEFAULT_GAME_MODE, presentationPhase } from '../game/content/modes';

/** Arrival changes this run's music; a later lower merge cannot undo it. */
export function bgmCue(state: Pick<SessionState, 'status' | 'phase' | 'highestStage'> & Partial<Pick<SessionState, 'mode'>>): BgmCue {
  if (state.status === 'ready' || state.status === 'game-over') return 0;
  if (state.highestStage >= 33) return 'silence';
  if (state.highestStage >= 32) return 'theory-incarnation';
  if (state.highestStage >= 31) return 'board-executor';
  return presentationPhase(state.mode ?? DEFAULT_GAME_MODE, state.phase);
}
